var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeBbDefault(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4706_10022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.882 6.68541C23.7463 6.17482 23.4789 5.70883 23.1065 5.33407C22.7341 4.9593 22.2699 4.68891 21.7602 4.54996C19.8838 4.04541 12.3838 4.04541 12.3838 4.04541C12.3838 4.04541 4.88379 4.04541 3.00743 4.54996C2.49772 4.68891 2.03345 4.9593 1.66108 5.33407C1.28871 5.70883 1.02129 6.17482 0.885607 6.68541C0.383789 8.56996 0.383789 12.5 0.383789 12.5C0.383789 12.5 0.383789 16.43 0.885607 18.3145C1.02129 18.8251 1.28871 19.2911 1.66108 19.6658C2.03345 20.0406 2.49772 20.311 3.00743 20.45C4.88379 20.9545 12.3838 20.9545 12.3838 20.9545C12.3838 20.9545 19.8838 20.9545 21.7602 20.45C22.2699 20.311 22.7341 20.0406 23.1065 19.6658C23.4789 19.2911 23.7463 18.8251 23.882 18.3145C24.3838 16.43 24.3838 12.5 24.3838 12.5C24.3838 12.5 24.3838 8.56996 23.882 6.68541Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9292 16.0687V8.9314L16.2019 12.5L9.9292 16.0687Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4706_10022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.359863 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBbDefault);
export default __webpack_public_path__ + "static/media/YoutubeBBDefault.736dc1807e7e72099a10a97b3af0d01b.svg";
export { ForwardRef as ReactComponent };